export const MEMBER_TYPES = {
    Nurses: 'nurses',
    Hr: 'hr',
    Reception: 'reception',
    Doctors: 'doctors'
};
